import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { averagegain } from "../Utils/AverageGain";
import { averageloss } from "../Utils/AverageLoss";
import { bearishhammerstick } from "./BearishHammerStick";
import { bullishhammerstick } from "./BullishHammerStick";
import CandlestickFinder from "./CandlestickFinder";

var HangingMan =
/*#__PURE__*/
function (_CandlestickFinder) {
  _inherits(HangingMan, _CandlestickFinder);

  function HangingMan() {
    var _this;

    _classCallCheck(this, HangingMan);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HangingMan).call(this));
    _this.name = "HangingMan";
    _this.requiredCount = 5;
    return _this;
  }

  _createClass(HangingMan, [{
    key: "logic",
    value: function logic(data) {
      var isPattern = this.upwardTrend(data);
      isPattern = isPattern && this.includesHammer(data);
      isPattern = isPattern && this.hasConfirmation(data);
      return isPattern;
    }
  }, {
    key: "upwardTrend",
    value: function upwardTrend(data) {
      var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var end = confirm ? 3 : 4; // Analyze trends in closing prices of the first three or four candlesticks

      var gains = averagegain({
        values: data.close.slice(0, end),
        period: end - 1
      });
      var losses = averageloss({
        values: data.close.slice(0, end),
        period: end - 1
      }); // Upward trend, so more gains than losses

      return gains > losses;
    }
  }, {
    key: "includesHammer",
    value: function includesHammer(data) {
      var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var start = confirm ? 3 : 4;
      var end = confirm ? 4 : undefined;
      var possibleHammerData = {
        open: data.open.slice(start, end),
        close: data.close.slice(start, end),
        low: data.low.slice(start, end),
        high: data.high.slice(start, end)
      };
      var isPattern = bearishhammerstick(possibleHammerData);
      isPattern = isPattern || bullishhammerstick(possibleHammerData);
      return isPattern;
    }
  }, {
    key: "hasConfirmation",
    value: function hasConfirmation(data) {
      var possibleHammer = {
        open: data.open[3],
        close: data.close[3],
        low: data.low[3],
        high: data.high[3]
      };
      var possibleConfirmation = {
        open: data.open[4],
        close: data.close[4],
        low: data.low[4],
        high: data.high[4]
      }; // Confirmation candlestick is bearish

      var isPattern = possibleConfirmation.open > possibleConfirmation.close;
      return isPattern && possibleHammer.close > possibleConfirmation.close;
    }
  }]);

  return HangingMan;
}(CandlestickFinder);

export { HangingMan as default };
export function hangingman(data) {
  return new HangingMan().hasPattern(data);
}